import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { InputGroup, Label } from 'reactstrap';
import { CloseCircleOutlined } from '@ant-design/icons';
import { Input } from 'antd';
// Local Deps
import './NFInputGroup.scss';

const { Search } = Input;

export default class NFInputGroup extends Component {
  static propTypes = {
    addon: PropTypes.any,
    onAddonClick: PropTypes.func,
    onKeyDown: PropTypes.func,
    onChange: PropTypes.func,
    addonType: PropTypes.string,
    label: PropTypes.string,
    text: PropTypes.string,
  };
  static defaultProps = {
    addon: '',
    addonType: 'append',
    onAddonClick: () => null,
    onKeyDown: () => null,
    onChange: () => null,
    label: '',
    text: '',
  };

  render() {
    const {
      addonType,
      addon,
      onAddonClick,

      label,
      onKeyDown,
      onChange,
      text,
      ...rest
    } = this.props;

    const suffix = text ? (
      <CloseCircleOutlined
        onClick={() => {
          const e = {
            target: {
              value: '',
            },
          };
          onChange(e);
          onAddonClick();
        }}
        style={{ color: 'rgba(0,0,0,.45)' }} />
    ) : (
      <span />
    );

    return (
      <div className="nf-input-group">
        <InputGroup>
          {label && <Label>{label}</Label>}
          <Search
            enterButton
            small
            onChange={onChange}
            onKeyDown={e => onKeyDown(e, text)}
            onSearch={() => onAddonClick(text)}
            value={text}
            suffix={suffix}
            {...rest}
          />
          {/* {addon && (
            <InputGroupAddon
              addonType={addonType}
              onClick={() => onAddonClick(text)}
            >
              {addon}
            </InputGroupAddon>
          )} */}
        </InputGroup>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/FormBuilder/NFInputGroup/NFInputGroup.jsx